import React, { useEffect, useState } from "react";
import UserPageSection from "./Content";
import deodLogo from "../../../image/Logo.png";
import UsdtLogo from "../../../image/tether-logo.png";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import {
  OldStakeAbiFour,
  OldStakeAddressFour,
  SecondOldStakeAbiFour,
  SecondOldStakeAddressFour,
  stake5BSC,
  stake5BSCABI,
  StakeAbiFour,
  StakeAbiFourUpdate,
  StakeAbiThree,
  StakeAbiTwo,
  StakeAddressFour,
  StakeAddressThree,
  StakeAddressTwo,
  stakeNAddress,
  stakeNAbi,
} from "../Abi/Content";
import axios from "axios";
import { BigNumber } from "bignumber.js";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";
import { dummyDatas, showDeodMaintenanceAlert } from "../../../dummyData";
import { ismintedFour } from "../../../data";
import { getMaturityDate, stake5Deposits, stakeNDeposits } from "../Abi/stakingDeposits";
import tokensClaimedSummaryNefi1 from "../Abi/tokensClaimedSummaryNefi1.json";
import tokensClaimedSummaryNefi2 from "../Abi/tokensClaimedSummaryNefi2.json";
import Nefi1ClaimDeod from "../Abi/Nefi1ClaimDeod.json";
import Nefi2ClaimDeod from "../Abi/Nefi2ClaimDeod.json";
import PurchaseClaimDeod from "../Abi/PurchaseClaimDeod.json";
import referralclaimOutput from "../Abi/referralclaimOutput.json";
import mergedTransfer from "../Abi/mergedTransfer.json";
import tokenwallet from "../../../image/wallet.png";
import totalwithdrawnImg from "../../../image/money-bag.png";
import drawalImg from "../../../image/wallets2.png";
import rewardImg from "../../../image/coin.png";
import { encrypt } from "../../../utils/encrypt";
const UserstakeN = () => {
  const navigate = useNavigate();
  const [auth, setAuth] = useAuth({});
  const [refferal, setRefferal] = useState("");
  const [address, setAddress] = useState("");
  const [owner, setOwner] = useState("");
  const [ownership, setOwnership] = useState("");
  const [loading, setLoading] = useState(false);
  const [assignloading, setAssignLoading] = useState(false);
  const [adminloading, setAdminLoading] = useState(false);

  const [totalAdminAllotment, setTotalAdminAllotment] = useState(0);
  const [getBalance, setBalance] = useState("0");

  const [stackingData, setStackingData] = useState([]);
  const [wallet, setWallet] = useState("");
  const [amount, setAmount] = useState("");
  const [isFinalize, setIsFinalize] = useState(true);
  const [errors, setErrors] = useState({});
  const [copiedId, setCopiedId] = useState(null);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [usdtPrice, setUsdtPrice] = useState(0);

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [transferAmount, setTransferAmount] = useState("");
  const [rErrors, setTErrors] = useState({});
  const [balanceInputAddress, setBalanceInputAddress] = useState("");
  const [fetchedBalance, setFetchedBalance] = useState(null);
  const [balanceLoading, setBalanceLoading] = useState(false);

  console.log("owner", owner);

  const start_and_end = (address) => {
    if (address !== undefined) {
      return (
        address.substr(0, 10) +
        "...." +
        address.substr(address.length - 10, address.length)
      );
    }
    return address;
  };

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedId(id);

    setTimeout(() => setCopiedId(null), 1500);
  };

  const validate = () => {
    let newErrors = {};

    // Basic crypto wallet validation (ETH/BTC-like)
    const walletRegex = /^(0x[a-fA-F0-9]{40}|[13][a-km-zA-HJ-NP-Z1-9]{25,34})$/;

    if (!wallet) {
      newErrors.wallet = "Wallet address is required";
    } else if (!walletRegex.test(wallet)) {
      newErrors.wallet = "Invalid wallet address";
    }

    if (!amount) {
      newErrors.amount = "Amount is required";
    } else if (isNaN(amount) || Number(amount) <= 0) {
      newErrors.amount = "Enter valid amount";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClaimAPI = async (from, to, amount, trxHash, sent_by) => {
    const headers = {
      "Content-Type": "application/json",
    };

    const bodyData = {
      sender_address: encrypt(from),
      recipient_address: encrypt(to),
      amount: encrypt(amount),
      trx_hash: encrypt(trxHash),
      sent_by: encrypt(sent_by)

    };
    try {
      const resp = await axios.post(
        `https://stackbackend.decentrawood.com/api/v1/stack`,
        bodyData,
        { headers }
      );
      if (resp?.data?.status === 200) {
        toast.success(resp?.data?.message);
      } else {
        toast.error(resp?.data?.message || "Something went wrong");
      }

    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        toast.error(err_404);
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  };
  const getFinalizeStatus = async (address) => {
    try {
      const resp = await axios.get(`https://stackbackend.decentrawood.com/api/v1/stake/finalize/${address}`)
      console.log(resp.data.data)
      if (resp?.data?.data.length == 0) {
        setIsFinalize(false)
      } else if (resp?.data?.data[0].isFinalised == false) {
        setIsFinalize(false)
      } else if (resp?.data?.data[0].isFinalised == true) {
        setIsFinalize(true)
      }
    } catch (error) {
      console.log(error)
    }

  }
  console.log(isFinalize)
  const handleSubmit = async () => {

    // if (validate()) {
    //   setAssignLoading(true);
    //   try {
    //     let provider;
    //     if (window.ethereum) {
    //       provider = window.ethereum;
    //     } else if (window.web3) {
    //       provider = window.web3.currentProvider;
    //     } else {
    //       window.alert("No ethereum browser !checkout metamask");
    //     }
    //     if (provider) {
    //       if (provider !== window.ethereum) {
    //         console.error(
    //           "Not window.ethereum.Do you have multiple wallets installed"
    //         );
    //       }
    //       await provider.request({
    //         method: "eth_requestAccounts",
    //       });
    //     }
    //     const newProvider = new ethers.providers.Web3Provider(window.ethereum);
    //     const signer = newProvider.getSigner();
    //     const currentaccount = await signer.getAddress();
    //     const address = currentaccount.toLowerCase();
    //     const storeAddress = auth?.user?.address;
    //     if (address === storeAddress) {
    //       const StakeContract = new ethers.Contract(
    //         stakeNAddress,
    //         stakeNAbi,
    //         signer
    //       );
    //       const amountInWei = ethers.utils.parseUnits(
    //         amount.toString(),
    //         18
    //       );
    //       const txn = await StakeContract.userTransfer(wallet, amountInWei);
    //       const receipttxn1 = await txn.wait();
    //       if (receipttxn1.status !== 1) {
    //         toast.error("Error");
    //       } else {
    //         const hash = await receipttxn1.transactionHash;
    //         await handleClaimAPI(address, wallet, amount, hash, "self");
    //       }
    //     } else {
    //       toast.error("Connect correct wallet");
    //     }
    //   } catch (error) {
    //     console.log("loadBlockchainData", error);
    //     toast.error(`${JSON.stringify(error.reason)}`, {
    //       position: toast.POSITION.TOP_RIGHT,
    //     });
    //   }
    //   setAssignLoading(false);
    //   // window.location.reload(false);
    // }
  };

 /*Switch to Testnet*/ const networkData = {
    sepolia: {
      chainId: "0xaa36a7",
      chainName: "Sepolia Testnet",
      nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
      rpcUrls: ["https://rpc.sepolia.org"],
      blockExplorerUrls: ["https://sepolia.etherscan.io"],
    },
    bnbTestnet: {
      chainId: "0x61",
      chainName: "BNB Smart Chain Testnet",
      nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
      rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
      blockExplorerUrls: ["https://testnet.bscscan.com"],
    },

    /* --- BSC MAINNET --- */
    bsc: {
      chainId: "0x38", // 56 decimal
      chainName: "BNB Smart Chain Mainnet",
      nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
      rpcUrls: ["https://bsc-dataseed.binance.org/"],
      blockExplorerUrls: ["https://bscscan.com"],
    },

    /* --- POLYGON MAINNET --- */
    polygon: {
      chainId: "0x89", // 137 decimal
      chainName: "Polygon Mainnet",
      nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
      rpcUrls: ["https://polygon-rpc.com/"],
      blockExplorerUrls: ["https://polygonscan.com"],
    },
  };
  const switchNetworks = async (networkName) => {
    const network = networkData[networkName];
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: network.chainId }],
      });
      console.log("network switched");
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [network],
          });
          console.log("network switched");
        } catch (addError) {
          console.log(addError);
          // handle "add" error
        }
      }
      // handle other "switch" errors
    }
  };

  const loadData = async () => {
    setLoading(true);
    try {
      let provider;
      if (window?.ethereum) {
        provider = window?.ethereum;
      } else if (window?.web3) {
        provider = window?.web3?.currentProvider;
      } else {
        window.alert("No ethereum browser !checkout metamask");
      }
      if (provider) {
        if (provider !== window?.ethereum) {
          console.error(
            "Not window.ethereum.Do you have multiple wallets installed"
          );
        }
        await provider.request({
          method: "eth_requestAccounts",
        });
      }
      const oldProvider = new ethers.providers.Web3Provider(window.ethereum);
      const network = await oldProvider.getNetwork();
      await switchNetworks('bsc')
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      // const address = ('0xea5DF69917a713db6a204ed743874D3fd5Af15B1').toLowerCase();
      const address = currentaccount.toLowerCase();
      const StakeContract = new ethers.Contract(
        stakeNAddress,
        stakeNAbi,
        signer
      );
      await getFinalizeStatus(address)
      const owner = await StakeContract.owner()
      setOwner(owner)
      console.log("owner", owner);

      const getBalance = await StakeContract.getBalance(address)
      setBalance(ethers.utils.formatEther(getBalance))
      
      const totaladminAllotments = await StakeContract.totalAdminAllotment()
      setTotalAdminAllotment(ethers.utils.formatEther(totaladminAllotments))
    } catch (error) {
      console.log("loadBlockchainData", error);
    }
    setLoading(false);
  };
  const filteredDeposits = stakeNDeposits.filter(
    (item) => item.address.toLowerCase() === address.toLowerCase()
  );

  const nefi1Data = tokensClaimedSummaryNefi1.filter(
    (item) => item.address.toLowerCase() === address.toLowerCase()
  );

  const nefi2Data = tokensClaimedSummaryNefi2.filter(
    (item) => item.address.toLowerCase() === address.toLowerCase()
  );

  const purchaseClaimData = PurchaseClaimDeod.filter(
    (item) => item.user.toLowerCase() === address.toLowerCase()
  );

  const referralClaimData = referralclaimOutput.filter(
    (item) => item.user.toLowerCase() === address.toLowerCase()
  );

  const mergedTransferData = mergedTransfer.filter(
    (item) => item.from.toLowerCase() === address.toLowerCase()
  );

  const calculateGrandTotalDeod = () => {
    let total = new BigNumber(0);
    nefi1Data.forEach(value => {
      const deodData = Nefi1ClaimDeod.find(item => item.user.toLowerCase() === value.address.toLowerCase());
      if (deodData) total = total.plus(deodData.finaltotalAllotment || 0);
    });
    nefi2Data.forEach(value => {
      const deodData = Nefi2ClaimDeod.find(item => item.user.toLowerCase() === value.address.toLowerCase());
      if (deodData) total = total.plus(deodData.finaltotalAllotment || 0);
    });
    purchaseClaimData.forEach(item => {
      total = total.plus(item.finaltotalAllotment || 0);
    });
    referralClaimData.forEach(item => {
      total = total.plus(item.finaltotalReferral || 0);
    });
    return total;
  };
  const grandTotalDeod = calculateGrandTotalDeod();

  const handleGetStackingData = async () => {
    const token = auth?.user?.token;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const resp = await axios.get(`https://stackbackend.decentrawood.com/api/v1/stack/${auth?.user?.address}`, {
        headers,
      });
      if (resp.status === 200) {
        if (resp?.data?.status === 200) {
          setStackingData(resp?.data?.data);
        } else {
          toast.error("Error", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } else {
        toast.error("Error", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      if (error.response.status === 400) {
        var err_400 = error?.response?.data?.message;
        toast.error(err_400);
      } else if (error.response.status === 401) {
        const err_401 = error?.response?.data?.message;
        toast.error(err_401);
      } else if (error.response.status === 404) {
        const err_404 = error?.response?.data?.message;
        toast.error(err_404);
      } else if (error.response.status === 500) {
        const err_500 = error?.response?.data?.message;
        toast.error(err_500);
      } else {
        console.log("Error in Register", error);
        toast.error("something went wrong");
      }
    }
  };
  function timestampToDate(seconds) {
    const date = new Date(seconds * 1000); // Convert to milliseconds
    return date.toLocaleString(); // Example: "6/30/2025, 7:45:12 PM"
  }

  const handleClaim = async () => {
    setLoading(true);
    try {
      let provider;
      if (window.ethereum) {
        provider = window.ethereum;
      } else if (window.web3) {
        provider = window.web3.currentProvider;
      } else {
        window.alert("No ethereum browser !checkout metamask");
      }
      if (provider) {
        if (provider !== window.ethereum) {
          console.error(
            "Not window.ethereum.Do you have multiple wallets installed"
          );
        }
        await provider.request({
          method: "eth_requestAccounts",
        });
      }
      const newProvider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      const storeAddress = auth?.user?.address;
      if (address === storeAddress) {
        const StakeContract = new ethers.Contract(
          stakeNAddress,
          stakeNAbi,
          signer
        );
        const txn = await StakeContract.claimAllPrincipal();
        const receipttxn1 = await txn.wait();
        if (receipttxn1.status !== 1) {
          toast.error("Error");
        } else {
          const hash = await receipttxn1.transactionHash;
          //   await handleClaimAPI(hash);
          alert("claim Successful")
        }
      } else {
        toast.error("Connect correct wallet");
      }
    } catch (error) {
      console.log("loadBlockchainData", error);
      toast.error(`${JSON.stringify(error.reason)}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    setLoading(false);
    window.location.reload(false);
  };
  const transferOwnership = async () => {
    try {
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      // const address = ('0xe67f2a68dA7A47A944f5d56A76c5e03aE1c71959').toLowerCase();
      const address = currentaccount.toLowerCase();
      const StakeContract = new ethers.Contract(
        stakeNAddress,
        stakeNAbi,
        signer
      );
      const withdraw = await StakeContract.transferOwnership(ownership)
      const rcpt = await withdraw.wait()
      alert("Transfer Ownership Successful")
    } catch (error) {
      console.log(error)
      alert(error.message)
    }


  }
  const handleAdminTransfer = async () => {
    let newErrors = {};

    if (!from || from.length !== 42) {
      newErrors.from = "Invalid From Address";
    }

    if (!to || to.length !== 42) {
      newErrors.to = "Invalid To Address";
    }

    if (!transferAmount || transferAmount <= 0) {
      newErrors.amount = "Enter valid amount";
    }

    setTErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setAdminLoading(true);
    try {
      let provider;
      if (window.ethereum) {
        provider = window.ethereum;
      } else if (window.web3) {
        provider = window.web3.currentProvider;
      } else {
        window.alert("No ethereum browser !checkout metamask");
      }
      if (provider) {
        if (provider !== window.ethereum) {
          console.error(
            "Not window.ethereum.Do you have multiple wallets installed"
          );
        }
        await provider.request({
          method: "eth_requestAccounts",
        });
      }
      const newProvider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      const storeAddress = auth?.user?.address;
      if (address === storeAddress) {
        const StakeContract = new ethers.Contract(
          stakeNAddress,
          stakeNAbi,
          signer
        );
        const amountInWei = ethers.utils.parseUnits(
          transferAmount.toString(),
          18
        );

        const txn = await StakeContract.adminTransfer(from, to, amountInWei);
        const receipttxn1 = await txn.wait();
        if (receipttxn1.status !== 1) {
          toast.error("Error");
        } else {
          const hash = await receipttxn1.transactionHash;
          await handleClaimAPI(from, to, transferAmount, hash, "admin");
        }
      } else {
        toast.error("Connect correct wallet");
      }
    } catch (error) {
      console.log("loadBlockchainData", error);
      toast.error(`${JSON.stringify(error.reason)}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    setAdminLoading(false);
    window.location.reload(false);
  };
  const handleClaimReferral = async () => {
    setLoading(true);
    try {
      let provider;
      if (window.ethereum) {
        provider = window.ethereum;
      } else if (window.web3) {
        provider = window.web3.currentProvider;
      } else {
        window.alert("No ethereum browser !checkout metamask");
      }
      if (provider) {
        if (provider !== window.ethereum) {
          console.error(
            "Not window.ethereum.Do you have multiple wallets installed"
          );
        }
        await provider.request({
          method: "eth_requestAccounts",
        });
      }
      const newProvider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      const address = currentaccount.toLowerCase();
      // const address = ('0xe67f2a68dA7A47A944f5d56A76c5e03aE1c71959').toLowerCase();
      const storeAddress = auth?.user?.address;
      if (address === storeAddress) {
        const StakeContract = new ethers.Contract(
          stakeNAddress,
          stakeNAbi,
          signer
        );
        const txn = await StakeContract.claimAllRewards();
        const receipttxn1 = await txn.wait();
        if (receipttxn1.status !== 1) {
          toast.error("Error");
        } else {
          const hash = await receipttxn1.transactionHash;
          // await handleClaimAPI(hash);
          alert('Claim Successfully')
        }
      } else {
        toast.error("Connect correct wallet");
      }
    } catch (error) {
      console.log("loadBlockchainData", error);
      toast.error(`${JSON.stringify(error.reason)}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    setLoading(false);
    // window.location.reload(false);
  };
  const handleEmergencyWithdraw = async () => {
    try {
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      // const address = ('0xe67f2a68dA7A47A944f5d56A76c5e03aE1c71959').toLowerCase();
      const address = currentaccount.toLowerCase();
      const StakeContract = new ethers.Contract(
        stakeNAddress,
        stakeNAbi,
        signer
      );
      // const withdraw = await StakeContract.emergencyWithdraw()
      // const rcpt = await withdraw.wait()
      alert("Emergency Token Withdrawn")
    } catch (error) {

    }
  }

  const confirmFinalize = async () => {
    try {
      // return alert('error occured')
      const newProvider = new ethers.providers.Web3Provider(window?.ethereum);
      const signer = newProvider.getSigner();
      const currentaccount = await signer.getAddress();
      // const address = ('0xe67f2a68dA7A47A944f5d56A76c5e03aE1c71959').toLowerCase();
      const address = currentaccount.toLowerCase();
      const StakeContract = new ethers.Contract(
        stakeNAddress,
        stakeNAbi,
        signer
      );
      const payload = {
        "sender_address": encrypt(address),
        "isFinalised": encrypt(true)
      }
      // const withdraw = await StakeContract.emergencyWithdraw()
      // const rcpt = await withdraw.wait()
      const apiUrl = `https://stackbackend.decentrawood.com/api/v1/stake/finalize/`
      const resp = await axios.post(apiUrl, payload)
      console.log(resp)
      await getFinalizeStatus(address)
      setShowConfirmModal(false)
      alert('Transfer Finalised')
      toast.success("Transfer Finalised", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } catch (error) {
      console.log(error)
      alert(error.message)
      toast.error("error while finalising", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }

  const handleGetBalance = async () => {
    if (!balanceInputAddress || balanceInputAddress.length !== 42) {
      toast.error("Please enter a valid wallet address");
      return;
    }

    setBalanceLoading(true);
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const StakeContract = new ethers.Contract(
        stakeNAddress,
        stakeNAbi,
        provider
      );

      const balance = await StakeContract.getBalance(balanceInputAddress);
      setFetchedBalance(ethers.utils.formatEther(balance));
    } catch (error) {
      console.error("Error fetching balance:", error);
      toast.error("Error fetching balance. Make sure the address is correct.");
    }
    setBalanceLoading(false);
  };

  useEffect(() => {
    async function handleData() {
      await loadData();
    }
    handleData();

    return () => {
      if (window?.ethereum) {
        switchNetworks('bsc').catch(console.error);
      }
    };
  }, []);

  useEffect(() => {
    if (
      auth?.user?.address &&
      auth?.user?.referralAddress &&
      auth?.user?.token
    ) {
      setRefferal(auth?.user?.referralAddress);
      setAddress(auth?.user?.address);
      // setAddress(`0xd4068cf47D8EEFf33217d7926aE38bf066f738E4`.toLowerCase());
      handleGetStackingData();
    }
  }, [auth]);

  useEffect(() => {
    async function handleGetParaswapPrice() {
      if (getBalance == 0) {
        setUsdtPrice(0);
      } else {
        try {
          let x;
          x = getBalance * 10 ** 18;
          let z = new BigNumber(x);
          let a = z.toFixed();
          const Paraswap = `https://backend.decentrawood.com/commonAPI/getDeodPrice`;
          console.log("Paraswap", a);
          const getParaswapData = await axios.get(Paraswap);
          if (getParaswapData.status === 200) {
            let finalUSDTPrice =
              getParaswapData?.data?.data?.priceRoute?.destAmount;
            finalUSDTPrice = (finalUSDTPrice / 10 ** 18).toFixed(2);
            setUsdtPrice((getBalance / finalUSDTPrice).toFixed(2));
          }
        } catch (error) {
          console.log("error in deod price paraswap api", error);
        }
      }
    }
    handleGetParaswapPrice();
  }, [getBalance]);

  return (
    <div>
      <UserPageSection>
        <div>
          <div className="marquee">
            <h3 className="text-warning fw-bolder">Data migration is in process, it will be fully completed by next week</h3>

            <style jsx>{`
        .marquee {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
        }

        .marquee h3 {
          display: inline-block;
          padding-left: 100%;
          animation: marquee 10s linear infinite;
        }

        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
          </div>
          <div className="row">

            <div className="col-6">
              <button
                className="btn connect-btn mx-2 boobtn"
              // onClick={() => navigate("/stack-token-vN")}
              >
                Stake Token N
              </button>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12">

            </div>
          </div>

          <div className="row g-4 my-4 align-items-stretch">

            {/* Total DEOD */}
            <div className="col-12 col-md-6 d-flex">
              <div className="app-card w-100 d-flex flex-column justify-content-between">

                <div>
                  <div className="app-card__header">
                    <span className="app-card__title">
                      Total DEOD Alloted
                    </span>

                    <div className="app-card__icon app-card__icon--blue">
                      <img src={tokenwallet} alt="" className="app-card__img" />
                    </div>
                  </div>

                  <div className="app-card__value mt-3">
                    {grandTotalDeod.isGreaterThan(0)
                      ? grandTotalDeod.toFixed(5)
                      : "0"}{" "}
                    DEOD
                  </div>
                </div>

                <div>
                  <div className="app-card__header">
                    <span className="app-card__title">
                      Available DEOD
                    </span>

                    <div className="app-card__icon app-card__icon--blue">
                      <img src={rewardImg} alt="" className="app-card__img" />
                    </div>
                  </div>

                  <div className="app-card__value mt-3">
                    {(+getBalance).toFixed(3)}
                    {" "}
                    DEOD
                  </div>
                  <div className="app-card__value mt-3" style={{ fontSize: `20px` }}>
                    {(+usdtPrice).toFixed(3)}
                    {" "}
                    $
                  </div>
                </div>

              </div>
            </div>
            {/* Assign Tokens */}
            {isFinalize == false &&

              <div className="col-12 col-md-6 d-flex">
                <div className="app-card w-100 d-flex flex-column">

                  <div>
                    <div className="app-card__header">
                      <span className="app-card__title">
                        Transfer Tokens
                      </span>

                      <div className="app-card__icon app-card__icon--blue">
                        <img src={totalwithdrawnImg} alt="" className="app-card__img" />
                      </div>
                    </div>

                    <div className="app-form mt-3">

                      {/* Wallet */}
                      <div className="app-form__group">
                        <input
                          type="text"
                          className={`app-form__input ${errors.wallet ? "app-form__input--error" : ""}`}
                          placeholder="Enter Wallet Address"
                          value={wallet}
                          onChange={(e) => setWallet(e.target.value)}
                        />
                        {errors.wallet && (
                          <span className="app-form__error">{errors.wallet}</span>
                        )}
                      </div>

                      {/* Amount */}
                      <div className="app-form__group">
                        <input
                          type="number"
                          className={`app-form__input ${errors.amount ? "app-form__input--error" : ""}`}
                          placeholder="Enter Amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                        {errors.amount && (
                          <span className="app-form__error">{errors.amount}</span>
                        )}
                      </div>

                    </div>
                  </div>

                  <button
                    className="app-btn app-btn--primary mt-auto flex items-center justify-center gap-2"
                    onClick={handleSubmit}
                    disabled={assignloading}
                  >
                    {assignloading ? (
                      <>
                        <span className="loader"></span>
                        Assigning...
                      </>
                    ) : (
                      "Transfer Tokens"
                    )}
                  </button>

                </div>
              </div>}



            {/* Ownership Transfer */}
            {(address.toLowerCase() === `0x7f967ec284cE3E3E3503C19dB74dc697aEa4c0F2`.toLowerCase() ||
              address.toLowerCase() === owner.toLowerCase()) && (
                <>
                  {/* <div className="col-12 d-flex">
                    <div className="app-card w-100 d-flex flex-column">
                      <div>
                        <div className="app-card__header">
                          <span className="app-card__title">
                            Total Staked (Admin)
                          </span>
                          <div className="app-card__icon app-card__icon--blue">
                            <i className="bi bi-bank" style={{ fontSize: "1.2rem", color: "#f5841f" }}></i>
                          </div>
                        </div>
                        <div className="mt-3 fs-3 fw-bold" style={{ color: "#f5841f" }}>
                          {(+totalAdminAllotment).toFixed(2)} DEOD
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div className="col-12 col-md-6 d-flex">
                    <div className="app-card w-100 d-flex flex-column">

                      <div>
                        <div className="owner-box mt-2 mb-3">
                          <small className="owner-label">Current Owner</small>
                          <span className="owner-value">
                            {owner
                              ? `${owner.slice(0, 6)}...${owner.slice(-4)}`
                              : "Not Available"}
                          </span>
                        </div>


                        <div className="app-form mt-2">
                          <div className="app-form__group">
                            <input
                              type="text"
                              className="app-form__input"
                              placeholder="Enter new owner address"
                              value={ownership}
                              onChange={(e) => setOwnership(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>

                      <button
                        className="app-btn app-btn--danger mt-auto"
                        onClick={() => transferOwnership()}
                      >
                        Transfer Ownership
                      </button>

                    </div>
                  </div>

                  <div className="col-12 col-md-6 d-flex">
                    <div className="app-card w-100 d-flex flex-column">

                      <div>
                        <div className="app-card__header">
                          <span className="app-card__title">
                            Admin Transfer
                          </span>

                          <div className="app-card__icon app-card__icon--blue">
                            <img src={drawalImg} alt="" className="app-card__img" />
                          </div>
                        </div>

                        <div className="app-form mt-3">

                          {/* From Address */}
                          <div className="app-form__group">
                            <input
                              type="text"
                              className={`app-form__input ${rErrors.from ? "app-form__input--error" : ""}`}
                              placeholder="From Address"
                              value={from}
                              onChange={(e) => setFrom(e.target.value)}

                            />
                            {rErrors.from && (
                              <span className="app-form__error">{rErrors.from}</span>
                            )}
                          </div>

                          {/* To Address */}
                          <div className="app-form__group">
                            <input
                              type="text"
                              className={`app-form__input ${rErrors.to ? "app-form__input--error" : ""}`}
                              placeholder="To Address"
                              value={to}
                              onChange={(e) => setTo(e.target.value)}
                            />
                            {rErrors.to && (
                              <span className="app-form__error">{rErrors.to}</span>
                            )}
                          </div>

                          {/* Amount */}
                          <div className="app-form__group">
                            <input
                              type="number"
                              className={`app-form__input ${rErrors.amount ? "app-form__input--error" : ""}`}
                              placeholder="Enter Amount"
                              value={transferAmount}
                              onChange={(e) => setTransferAmount(e.target.value)}
                            />
                            {rErrors.amount && (
                              <span className="app-form__error">{rErrors.amount}</span>
                            )}
                          </div>

                        </div>
                      </div>

                      <button
                        className="app-btn app-btn--primary mt-auto py-2 flex items-center justify-center gap-2"
                        onClick={handleAdminTransfer}
                        disabled={adminloading}
                      >
                        {adminloading ? (
                          <>
                            <span className="loader"></span>
                            Transferring...
                          </>
                        ) : (
                          "Transfer Tokens"
                        )}
                      </button>

                    </div>
                  </div>
                </>


              )}

            {/* Get Balance Section */}
            {(address.toLowerCase() === `0x7f967ec284cE3E3E3503C19dB74dc697aEa4c0F2`.toLowerCase() ||
              address.toLowerCase() === owner.toLowerCase()) &&

              <div className="col-12 col-md-6 d-flex">
                <div className="app-card w-100 d-flex flex-column">
                  <div>
                    <div className="app-card__header">
                      <span className="app-card__title">
                        Get Balance
                      </span>
                      <div className="app-card__icon app-card__icon--blue">
                        <img src={rewardImg} alt="" className="app-card__img" />
                      </div>
                    </div>

                    <div className="app-form mt-3">
                      <div className="app-form__group">
                        <input
                          type="text"
                          className="app-form__input"
                          placeholder="Enter Wallet Address"
                          value={balanceInputAddress}
                          onChange={(e) => setBalanceInputAddress(e.target.value)}
                        />
                      </div>
                    </div>

                    {fetchedBalance !== null && (
                      <div className="mt-3">
                        <div className="owner-label">Balance</div>
                        <div className="app-card__value" style={{ fontSize: '24px' }}>
                          {fetchedBalance} DEOD
                        </div>
                      </div>
                    )}
                  </div>

                  <button
                    className="app-btn app-btn--primary mt-auto py-2 flex items-center justify-center gap-2"
                    onClick={handleGetBalance}
                    disabled={balanceLoading}
                  >
                    {balanceLoading ? (
                      <>
                        <span className="loader"></span>
                        Fetching...
                      </>
                    ) : (
                      "Get Balance"
                    )}
                  </button>
                </div>
              </div>}

          </div>
          {/* <div className="row justify-content-center my-4">
            <div className="col-12 col-md-6">
              <div className="card cus-card-token-ad text-center">
                <div className="card-body">
                  <h6>Total DEOD Alloted</h6>
                </div>
                <p className="mt-1"><strong>{grandTotalDeod.isGreaterThan(0) ? grandTotalDeod.toFixed(5) : "0"} DEOD</strong></p>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="card cus-card-token-ad">
                <div className="card-body">

              
                  <h5 className="text-center mb-4">Assign Tokens</h5>

                  <div className="mb-3">
                    <label className="form-label">Enter Wallet Address</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="0x..."
                      value={wallet}
                      onChange={(e) => setWallet(e.target.value)}
                    />
                    {errors.wallet && (
                      <small className="text-danger">{errors.wallet}</small>
                    )}
                  </div>

                 
                  <div className="mb-3">
                    <label className="form-label">Enter Amount</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                    {errors.amount && (
                      <small className="text-danger">{errors.amount}</small>
                    )}
                  </div>

                
                  <button
                    className="btn btn-primary w-100"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>

                </div>
              </div>
            </div>
         
            {(address.toLowerCase() == `0x7f967ec284cE3E3E3503C19dB74dc697aEa4c0F2`.toLowerCase() || address.toLowerCase() == owner.toLowerCase()) && <div className="col-12 col-md-6">
              <div className="card cus-card-token-ad text-center">
                <div className="card-body">
                  <h6>Ownership Transfer</h6>
                </div>
                <input type="text" placeholder="Eg. 0x0123..321" className="form form-control px-2 my-3" value={ownership} onChange={(e) => setOwnership(e.target.value)} />
                <button
                  className="btn connect-btn"
                  onClick={() => transferOwnership()}
                >
                  Transfer Ownership
                </button>
              </div>
            </div>}
          </div> */}


          {/* <div class="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Allotment Amount</th>
                  <th scope="col">Monthly Bonus Amount</th>
                  <th scope="col">Allotment Date</th>
                  <th scope="col">Maturity Date</th>
                </tr>
              </thead>
              <tbody>
                {filteredDeposits &&
                  filteredDeposits[0]?.allotments?.map((value, key) => {
                    return (
                      <tr>
                        <th scope="row">{key + 1}</th>
                        <td>{+ethers.utils.formatEther(value?.amount)}</td>
                        <td>
                          {(+ethers.utils.formatEther(value?.amount) *
                            5 / 1000).toFixed(5)}
                        </td>
                        <td>{timestampToDate(value?.startTime)}</td>
                        <td>{!value.isMatured ? getMaturityDate(value?.remainingTimePeriodInDays) : value?.maturityDateReadable}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div> */}

          {/* Staking History Table */}
          <div className="app-table-container">
            <table className="app-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Amount</th>
                  <th>To Address</th>
                  <th>From Address</th>
                  <th>Trx Hash</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>
                {stackingData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    <td>{item.amount} DEOD</td>

                    {/* To Address */}
                    <td className="app-address-cell">
                      <span className="app-address-text">
                        {start_and_end(item.sender_address)}
                      </span>


                    </td>

                    {/* From Address */}
                    <td className="app-address-cell">
                      <span className="app-address-text">
                        {start_and_end(item.recipient_address)}
                      </span>


                    </td>
                    <td className="app-address-cell">
                      <span className="app-address-text">
                        {start_and_end(item.trx_hash)}
                      </span>


                    </td>

                    <td>{item.createdAt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {nefi1Data.length > 0 && (
            <div className="mt-5">
              <h4 className="text-center text-warning">Tokens Claimed Summary Nefi 1</h4>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Address</th>
                      <th scope="col">Total Claimed NEFI 1</th>
                      <th scope="col">Total Alloted DEOD</th>
                    </tr>
                  </thead>
                  <tbody>
                    {nefi1Data.map((value, key) => {
                      const deodData = Nefi1ClaimDeod.find(
                        (item) => item.user.toLowerCase() === value.address.toLowerCase()
                      );
                      return (
                        <tr key={key}>
                          <th scope="row">{key + 1}</th>
                          <td>{value.address}</td>
                          <td>{value.totalClaimed}</td>
                          <td>{deodData ? deodData.finaltotalAllotment : "0"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {nefi2Data.length > 0 && (
            <div className="mt-5">
              <h4 className="text-center text-warning">Tokens Claimed Summary Nefi 2</h4>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Address</th>
                      <th scope="col">Total Claimed NEFI 2</th>
                      <th scope="col">Total Alloted DEOD</th>
                    </tr>
                  </thead>
                  <tbody>
                    {nefi2Data.map((value, key) => {
                      const deodData = Nefi2ClaimDeod.find(
                        (item) => item.user.toLowerCase() === value.address.toLowerCase()
                      );
                      return (
                        <tr key={key}>
                          <th scope="row">{key + 1}</th>
                          <td>{value.address}</td>
                          <td>{value.totalClaimed}</td>
                          <td>{deodData ? deodData.finaltotalAllotment : "0"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {purchaseClaimData.length > 0 && (
            <div className="mt-5">
              <h4 className="text-center text-warning">Purchase Claim DEOD</h4>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Address</th>
                      <th scope="col">Total Alloted DEOD</th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchaseClaimData.map((value, key) => (
                      <tr key={key}>
                        <th scope="row">{key + 1}</th>
                        <td>{value.user}</td>
                        <td>{value.finaltotalAllotment}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {referralClaimData.length > 0 && (
            <div className="mt-5">
              <h4 className="text-center text-warning">Referral Claim Output</h4>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Address</th>
                      <th scope="col">Total Referral DEOD</th>
                    </tr>
                  </thead>
                  <tbody>
                    {referralClaimData.map((value, key) => (
                      <tr key={key}>
                        <th scope="row">{key + 1}</th>
                        <td>{value.user}</td>
                        <td>{value.finaltotalReferral}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {mergedTransferData.length > 0 && (
            <div className="mt-5">
              <h4 className="text-center text-warning">NEFI 1/2 Transfer Details</h4>
              <div className="app-table-container">
                <table className="app-table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">From Address</th>
                      <th scope="col">To Address</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Token</th>
                      <th scope="col">Tx Hash</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mergedTransferData.map((value, key) => (
                      <tr key={key}>
                        <th scope="row">{key + 1}</th>
                        <td className="app-address-cell">
                          <span className="app-address-text">{start_and_end(value.from)}</span>
                          <button
                            className="btn btn-sm btn-outline-secondary border-0 p-0 text-white me-2"
                            onClick={() => handleCopy(value.from, `from-${key}`)}
                            title="Copy From Address"
                          >
                            {copiedId === `from-${key}` ? "✅" : "📋"}
                          </button>
                        </td>
                        <td className="app-address-cell">
                          <span className="app-address-text">{start_and_end(value.to)}</span>
                          <button
                            className="btn btn-sm btn-outline-secondary border-0 p-0 text-white me-2"
                            onClick={() => handleCopy(value.to, `to-${key}`)}
                            title="Copy To Address"
                          >
                            {copiedId === `to-${key}` ? "✅" : "📋"}
                          </button>
                        </td>
                        <td>{value.amount}</td>
                        <td className="app-address-cell">
                          <span className="app-address-text">{value.token == "0xeF57D11897fB03D7ecEc3B65e4608b2a1A1Fd16a" ? "NEFI 2" : "NEFI 1"}</span>
                          <button
                            className="btn btn-sm btn-outline-secondary border-0 p-0 text-white me-2"
                            onClick={() => handleCopy(value.token, `token-${key}`)}
                            title="Copy Token Address"
                          >
                            {copiedId === `token-${key}` ? "✅" : "📋"}
                          </button>
                        </td>
                        <td className="app-address-cell">
                          <span className="app-address-text">{start_and_end(value.txHash)}</span>
                          <button
                            className="btn btn-sm btn-outline-secondary border-0 p-0 text-white me-2"
                            onClick={() => handleCopy(value.txHash, `tx-${key}`)}
                            title="Copy Transaction Hash"
                          >
                            {copiedId === `tx-${key}` ? "✅" : "📋"}
                          </button>
                        </td>
                        <td className="app-address-cell">
                          {isFinalize == (false) ?
                            <button
                              className="claim-btn me-2"
                              onClick={() => {
                                setWallet(value.to);
                                setShowAssignModal(true);
                              }}
                            >
                              Transfer
                            </button>
                            :
                            <button className="claim-btn me-2 " style={{ background: `red` }} disabled>Transfer Finalised</button>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {isFinalize == (false) && <div className="mt-5 text-center">
            <h4 className="text-warning">Finalize Transfer</h4>
            <div className="d-flex justify-content-center">
              <button className="claim-btn" onClick={() => setShowConfirmModal(true)}>Finalize</button>
            </div>
          </div>}
          {/* Assign Token Modal */}
          {isFinalize == (false) && showAssignModal && (
            <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content text-white" style={{ backgroundColor: "#1e1e1e", border: "1px solid #333", borderRadius: "10px" }}>
                  <div className="modal-header border-bottom-0 pb-0">
                    <h5 className="modal-title">Assign Tokens</h5>
                    <button type="button" className="btn-close btn-close-white" onClick={() => setShowAssignModal(false)}></button>
                  </div>
                  <div className="modal-body p-4">
                    <div className="app-form mt-2">
                      <div className="app-form__group mb-3">
                        <label className="form-label text-secondary small mb-1">Wallet Address</label>
                        <input
                          type="text"
                          className={`app-form__input ${errors.wallet ? "app-form__input--error" : ""}`}
                          placeholder="Enter Wallet Address"
                          value={wallet}
                          onChange={(e) => setWallet(e.target.value)}
                        />
                        {errors.wallet && <span className="app-form__error">{errors.wallet}</span>}
                      </div>

                      <div className="app-form__group mb-4">
                        <label className="form-label text-secondary small mb-1">Amount</label>
                        <input
                          type="number"
                          className={`app-form__input ${errors.amount ? "app-form__input--error" : ""}`}
                          placeholder="Enter Amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                        {errors.amount && <span className="app-form__error">{errors.amount}</span>}
                      </div>
                    </div>

                    <button
                      className="app-btn app-btn--primary w-100 flex items-center justify-center gap-2 py-2"
                      onClick={() => {
                        handleSubmit();
                        if (wallet && amount) setShowAssignModal(false);
                      }}
                      disabled={assignloading}
                    >
                      {assignloading ? (
                        <>
                          <span className="loader"></span>
                          Assigning...
                        </>
                      ) : (
                        "Assign Tokens"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Confirm Finalize Modal */}
          {showConfirmModal && (
            <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content text-white" style={{ backgroundColor: "#1e1e1e", border: "1px solid #333", borderRadius: "10px" }}>
                  <div className="modal-header border-bottom-0 pb-0">
                    <h5 className="modal-title text-warning">Confirm Finalize</h5>
                    <button type="button" className="btn-close btn-close-white" onClick={() => setShowConfirmModal(false)}></button>
                  </div>
                  <div className="modal-body p-4 text-center">
                    <p className="mb-4" style={{ fontSize: "1.1rem" }}>
                      Are you sure you want to proceed? <br />
                      <strong className="text-danger mt-2 d-inline-block">By clicking finalize, you won't be able to transfer DEOD anymore.</strong>
                    </p>
                    <div className="d-flex justify-content-center gap-3">
                      <button className="btn btn-secondary px-4 py-2" onClick={() => setShowConfirmModal(false)}>Cancel</button>
                      <button
                        className="app-btn app-btn--primary px-4 py-2 border-0"
                        onClick={() => {
                          // TODO: implement actual finalize functional logic here
                          confirmFinalize()
                        }}
                      >
                        Confirm Finalize
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div >
      </UserPageSection >
    </div >
  );
};

export default UserstakeN;
